import Link from 'next/link';
import RightArrowIcon from '../svg/RightArrowIcon';

type ExperiencesCardProps = {
  subheader: string;
  title: string;
  description: string;
  btnText: string;
  href: string;
  icon: JSX.Element;
  extraClasses?: string;
};

export const ExperiencesCard: React.FC<ExperiencesCardProps> = ({
  subheader,
  title,
  description,
  btnText,
  href,
  icon,
  extraClasses,
}) => {
  return (
    <section
      className={`cursor-pointer bg-[#f5f5f5] flex flex-col p-3 rounded-2xl justify-between ${extraClasses} min-h-[370px]`}
    >
      <div className="flex flex-col mb-10">
        <div className="mb-4">{icon}</div>
        <div className="mb-4">
          <h5 className="font-normal font-inter text-sm text-black">
            {subheader}
          </h5>
          <h2 className="font-montserrat font-bold text-2xl text-black">
            {title}
          </h2>
        </div>
        <div>
          <p className="text-base font-inter font-normal text-black">
            {description}
          </p>
        </div>
      </div>
      <div className="px-4">
        <Link
          href={href}
          className="bg-black rounded-full w-full text-white flex flex-row justify-center items-center p-4 gap-3"
        >
          <RightArrowIcon />
          {btnText}
        </Link>
      </div>
    </section>
  );
};
